export default "__VITE_ASSET__cgmB7$N9__"